import HealthContainer from "../features/health/Health";

const HealthCheckPage = () => <HealthContainer />;

export default HealthCheckPage;